import React from "react";
import PropTypes from "prop-types";

function H1HeaderText({title, className, textColor, textAlign, fontWeight }) {
  return ( 
      <h1 className={`${textColor} ${textAlign} ${fontWeight} ${className && className}`}>{title}</h1>
  );
}

export default H1HeaderText;

H1HeaderText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
};

H1HeaderText.defaultProps = {
  fontWeight: "text-extra-bold",
  textColor: "text-gray-700",
  textAlign: "text-left"
};


